import confetti from "canvas-confetti";

/**
 * Tiny celebration helper. Calmer than typical confetti — fits the brand palette.
 */
export function celebrate(intensity = "normal") {
  const palette = ["#486a8f", "#3e6b52", "#c18848", "#7a5fb0", "#e9d8a6"];
  const burst = intensity === "big" ? 140 : 70;
  const spread = intensity === "big" ? 80 : 65;
  try {
    confetti({
      particleCount: burst,
      spread,
      startVelocity: 38,
      origin: { y: 0.7 },
      colors: palette,
      ticks: 220,
      gravity: 0.95,
    });
    if (intensity === "big") {
      setTimeout(() => {
        confetti({
          particleCount: 60,
          spread: 100,
          startVelocity: 28,
          origin: { x: 0.2, y: 0.7 },
          colors: palette,
          ticks: 200,
        });
        confetti({
          particleCount: 60,
          spread: 100,
          startVelocity: 28,
          origin: { x: 0.8, y: 0.7 },
          colors: palette,
          ticks: 200,
        });
      }, 200);
    }
  } catch (e) {}
}
